import React, { useEffect, useState } from "react";
import { SiWix } from "react-icons/si";
import { ClassNames } from "../../../../../helper";
import AuthModal from "./AuthModal";
import { WixInstallGuide } from "../constants";
import { useLocation , useNavigate} from "react-router-dom";

const ConnectWithWix = ({
  installHandler,
  integrationData,
  page,
  setPage,
  accessToken,
}) => {
  const [validAuth, setValidAuth] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [authName, setAuthName] = useState("New authentication");

  useEffect(() => {
    if (integrationData.data) {
      setAuthName(integrationData?.data?.accountname);
    }
  }, [integrationData]);

  
  useEffect(() => {

    const storedValidAuth = window.location.href
    console.log(storedValidAuth)
    const parseRedirectedUrl = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const codeParam = urlParams.get('code');
      if (codeParam) {
        setValidAuth(true);
      }
    };

    parseRedirectedUrl();
    // console.log(storedValidAuth)
    // if (storedValidAuth) {
    //   setValidAuth(true);
    // }

  }, []);

  const handleFinish = async (e) => {
    e.preventDefault();
   
    try {
      
      installHandler(false);
    } catch (error) {
      // setLoading(false);
      installHandler(false);
      return;
    }
  };

  return (
    <div className="my-6 text-gray-500 relative">
      {open ? (
        <div className="relative">
          <AuthModal setOpen={setOpen} setValidAuth={setValidAuth} />
        </div>
      ) : null}

      <div className="p-4">
        <div className="text-center mx-auto mb-4">
          Integrate CausalFunnel with your Wix account. The integration
          allows you to:
          <ul className="text-sm mt-2 text-gray-700">
            <li>Create and update contacts in Wix</li>
            <li>Send chat transcripts to Wix</li>
          </ul>
        </div>
        <div className="">
          <h3 className="text-lg font-semibold text-center my-3">
            Connect with Wix account
          </h3>
          <div>
            <p>The only thing you need is the active Wix account</p>
            <ol className="list-decimal list-inside">
              {WixInstallGuide?.map((item, index) => (
                <li key={index}>{item.content}</li>
              ))}
            </ol>
            <div className="border-2 p-4 my-3.5" onClick={() => setOpen(true)}>
              <div className="border-2 p-2.5 flex gap-1 items-center hover:cursor-pointer hover:bg-white hover:shadow-sm">
                <SiWix className="text-lg text-gray-800" />
                <p className="text-gray-700">{authName}</p>
              </div>
            </div>
            <p>
              We also described integration step by step in our{" "}
              <a
                href="https://www.causalfunnel.com/blog"
                target="_blank"
                rel="noreferrer noopener"
                className="text-indigo-600 hover:underline "
              >
                Knowledge base.
              </a>
            </p>
          </div>

          <hr className="my-3" />
          <div className="flex justify-between items-center">
            <div className="flex gap-x-2">
              <div
                className={`w-2 h-2 rounded-full ${
                  page === 1 ? "bg-indigo-500" : "bg-gray-300"
                } cursor-pointer`}
              ></div>
              
            </div>
            <div className="flex gap-x-4">
              <button
                className="text-gray-800 hover:text-indigo-600"
                onClick={() => installHandler(false)}
              >
                Cancel
              </button>
              <button
                className={ClassNames(
                  " px-6 py-2 rounded-md",
                  validAuth
                    ? "text-white bg-indigo-600"
                    : "disabled bg-gray-200 text-gray-500 cursor-auto"
                )}
                onClick={handleFinish}
                // disabled={loading}
              >
                Finish
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectWithWix;
